"use client";

import { BUSINESS_TYPES } from "@/features/quote/shared/quote-config";
import { ChoiceCard } from "@/features/quote/ui/ChoiceCard";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function BusinessStep() {
  const { state, setState, autoAdvance, goToStep, step, stepReady } = useWizard();

  return (
    <section>
      <StepHeading
        title="Hvilken type virksomhed?"
        body="Vælg den type lokale I har - så matcher vi med firmaer der har erfaring med netop det."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        {BUSINESS_TYPES.map((b) => (
          <ChoiceCard
            key={b.value}
            selected={state.business === b.value}
            onClick={() => {
              setState((p) => ({
                ...p,
                business: b.value,
                bbrPrefilled: { ...p.bbrPrefilled, business: false },
              }));
              autoAdvance();
            }}
            icon={b.icon}
            title={b.label}
            compact
          />
        ))}
      </div>
      {state.bbrPrefilled.business && (
        <p className="mt-2 text-[13px] text-ink-subtle">
          Hentet fra BBR - vælg et andet hvis det er forkert.
        </p>
      )}
      <StepNav
        onBack={step > 1 ? () => goToStep(step - 1) : undefined}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("business")}
        nextLabel="Næste →"
      />
    </section>
  );
}
